module.exports = __webpack_public_path__ + "static/media/pre-built-templates.b468eb4e.png";